import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { list } from '../../../../../common/classes/request-builder';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class CompradoresListsDefinition {
    public fincas: TypeAheadInterface<FincasModel> = list();
    public tipos: TypeAheadInterface<string> = 
        list(['...', null ], 
        ['Comercio', 'Comercio'], 
        ['Proveedor', 'Proveedor'], 
        ['Servicios Agrícolas', 'Servicios Agrícolas']
    );
}